import { Link } from 'react-router';

export type AppLogoProps = {
  logoSrc: string;
  homeUrl: string;
  appName?: string;
  alt?: string;
};

// TODO: remove this component if decision is to keep the logo in the AppSwitcher
export function AppLogo({
  logoSrc,
  homeUrl,
  appName,
  alt = 'logo',
}: AppLogoProps) {
  return (
    <Link aria-label="Go to home" to={homeUrl}>
      <div className="flex items-center gap-2">
        <img src={logoSrc} alt={alt} className="h-7" />
        {appName && <span className="text-base text-blue-950">{appName}</span>}
      </div>
    </Link>
  );
}
